<svg width="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1504 10.6504L12.0004 13.8004L8.85039 10.6504" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="2.5 2.5"/>
<circle cx="8" cy="8" r="7.375" transform="matrix(-1 0 0 1 20 4)" stroke="currentColor" stroke-width="1.25" stroke-dasharray="2.5 2.5"/>
</svg>
